import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { t } = useTranslation();
  const { setTheme } = useTheme();

  // Holat DOM dan o'qiladi (renderda emas, bosilganda) — shu sababli
  // birinchi renderda mos kelmaslik bo'lmaydi va bitta klik doim
  // yorug' ↔ qorong'i o'rtasida almashtiradi.
  const toggle = () => {
    const isDark = document.documentElement.classList.contains("dark");
    setTheme(isDark ? "light" : "dark");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={t("common.theme")}
      title={t("common.theme")}
      className="relative"
    >
      {/* Ikonka almashinuvi sof CSS: JS joriy mavzuni o'qimaydi. */}
      <Sun className="size-4 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
      <Moon className="absolute size-4 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
    </Button>
  );
}
